import { IconListProps } from '../../reusable';

const listItems: IconListProps['listItems'] = [
  {
    icon: 'Anxiety',
    text: 'Anxiety',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'BipolarDisorder',
    text: 'Bipolar disorder',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'Depression',
    text: 'Depression',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'Ocd',
    text: 'OCD (Obsessive compulsive disorder)',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'Ptsd',
    text: 'PTSD (Post-traumatic stress disorder)',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'Adhd',
    text: 'ADHD (Attention-deficit/hyperactivity disorder)',
    color: 'secondary',
    styleType: 'custom',
  },
  {
    icon: 'Cap',
    text: 'Children and adolescents',
    color: 'secondary',
    styleType: 'custom',
  },
];

export default listItems;
